<template>
  <div
    class="video-container"
    @mouseover="playerVisibility = true"
    @mouseleave="playerVisibility = false"
  >
    <div id="youtube-player"></div>
    <background-player-controls
      @play-pause="playOrPause"
      @mute-sound="muteOrSound"
      :videoState="videoState"
      :soundState="soundState"
      :mini-player="miniPlayer"
    />
    <bg-thumbnail :url="thumbnailURL" />
    <button
      v-if="showPlayButton"
      type="button"
      class="btn btn-mini-player p-0 m-0"
      @click="playOrPause"
    >
      <b-spinner v-if="loading_player" variant="light"></b-spinner>
      <i v-else :class="ICON_MAP[videoState]"></i>
    </button>
  </div>
</template>
<script>
import BackgroundPlayerControls from "@/components/preview/BackgroundPlayerControls.vue";
import BgThumbnail from "@/components/preview/BgThumbnail.vue";
import { youtubeParser } from "@/functions/helpers";

export default {
  components: { BackgroundPlayerControls, BgThumbnail },
  props: {
    url: {
      type: String,
      default: ""
    },
    miniPlayer: {
      type: Boolean,
      default: false
    },
    size: {
      type: Object,
      default: () => ({
        width: 1920,
        height: 1080
      })
    }
  },
  mounted() {
    this.onYouTubeIframeAPIReady();
  },
  computed: {
    showPlayButton() {
      if (this.loading_player) return true;

      if (this.videoState == "paused") return true;

      return this.miniPlayer && this.playerVisibility;
    },
    ICON_MAP() {
      return {
        paused: "icon-play1",
        ended: "icon-play1",
        playing: "icon-pause2"
      };
    },
    thumbnailURL() {
      return `https://img.youtube.com/vi/${youtubeParser(
        this.url
      )}/maxresdefault.jpg`;
    }
  },
  data() {
    return {
      player: null,
      done: false,
      playerVisibility: true,
      loading_player: false,
      videoState: "playing",
      soundState: "muted"
    };
  },
  methods: {
    onYouTubeIframeAPIReady() {
      this.player = new YT.Player("youtube-player", {
        width: this.size.width,
        height: this.size.height,
        videoId: youtubeParser(this.url),
        events: {
          onReady: this.onPlayerReady,
          onStateChange: this.onPlayerStateChange
        },
        rel: 0,
        playerVars: {
          wmode: "opaque",
          autoplay: 1,
          mute: 1,
          controls: 0,
          loop: 1,
          rel: 0,
          showinfo: 0,
          enablejsapi: 1,
          playsinline: 1,
          disablekb: 1,
          playlist: youtubeParser(this.url),
          modestbranding: 1,
          fs: 0,
          iv_load_policy: 3,
          autohide: 0
        },
        origin: window.location.host
      });
    },
    onPlayerReady(event) {
      event.target.playVideo();
      event.target.mute();
      this.loading_player = true;
    },
    onPlayerStateChange(event) {
      if (event.data == window.YT.PlayerState.PLAYING) {
        this.videoState = "playing";
        this.loading_player = true;
        setTimeout(() => {
          if (document.querySelector(".bg-thumbnail")) {
            document.querySelector(".bg-thumbnail").style.opacity = 0;
          }
          this.loading_player = false;
          this.playerVisibility = false;
        }, 2850);
      }

      if (event.data == window.YT.PlayerState.PAUSED) {
        this.videoState = "paused";
        this.playerVisibility = true;
      }

      if (event.data == window.YT.PlayerState.ENDED) {
        this.videoState = "ended";
        document.querySelector(".bg-thumbnail").style.opacity = 1;
        this.playerVisibility = true;
      }
    },
    playOrPause() {
      if (this.videoState == "paused") {
        this.loading_player = true;
        document.querySelector(".bg-thumbnail").style.opacity = 1;
        this.videoState = "playing";
        setTimeout(() => {
          this.player.playVideo();
        }, 2000);
      } else {
        document.querySelector(".bg-thumbnail").style.opacity = 1;
        this.videoState = "paused";
        setTimeout(() => {
          this.player.pauseVideo();
        }, 2000);
      }
    },
    muteOrSound() {
      if (this.player.isMuted()) {
        this.player.unMute();
        this.soundState = "sound";
      } else {
        this.player.mute();
        this.soundState = "muted";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  margin-top: -2vw;
  margin-bottom: -2vw;
  @media screen and (min-width: 1500px) {
    margin-top: -9vw;
    margin-bottom: -2vw;
  }

  ::v-deep iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
